import { Badge } from '@givebutter/primitives/badge';
import { faTicket } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as LinkedResourcePopover from 'components/tasks/LinkedResourcePopover';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { LinkableTicket } from 'types/domain';

const TicketResourcePopover = ({ ticket }: { ticket?: LinkableTicket }) => {
    const { accountId } = useCurrentAccount();
    if (!ticket) return null;

    return (
        <LinkedResourcePopover.Root>
            <LinkedResourcePopover.Header>
                <FontAwesomeIcon icon={faTicket} className="text-gray-500" />
                <LinkedResourcePopover.Link to={`/accounts/${accountId}/tickets/${ticket.id}`}>
                    {ticket.title}
                </LinkedResourcePopover.Link>

                <Badge
                    className="flex-shrink-0"
                    size="sm"
                    color={ticket.checked_in_at ? 'success' : 'neutral'}
                >
                    {ticket.checked_in_at ? 'Checked in' : 'Not present'}
                </Badge>
            </LinkedResourcePopover.Header>
            <LinkedResourcePopover.Content>
                {ticket.campaign && (
                    <div className="flex flex-col">
                        <p className="text-sm text-gray-500">Campaign</p>
                        <p className="text-base leading-snug text-gray-900">
                            {ticket.campaign.title}
                        </p>
                    </div>
                )}

                {ticket.contact && (
                    <div className="flex items-center justify-between gap-10">
                        <div className="flex flex-col">
                            <p className="text-sm text-gray-500">Contact</p>
                            <p className="flex items-center gap-1 text-base text-gray-900">
                                {ticket.contact?.first_name} {ticket.contact?.last_name}
                            </p>
                        </div>
                        <div className="flex items-center gap-2">
                            {ticket.contact.primary_email && (
                                <a
                                    href={`mailto:${ticket.contact.primary_email}`}
                                    className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-gray-100"
                                >
                                    <FontAwesomeIcon icon={faEnvelope} className="text-blue-500" />
                                </a>
                            )}

                            {ticket.contact.primary_phone && (
                                <a
                                    href={`tel:${ticket.contact.primary_phone}`}
                                    className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-gray-100"
                                >
                                    <FontAwesomeIcon icon={faPhone} className="text-blue-500" />
                                </a>
                            )}
                        </div>
                    </div>
                )}
            </LinkedResourcePopover.Content>
        </LinkedResourcePopover.Root>
    );
};

export { TicketResourcePopover };
